module.exports = __webpack_public_path__ + "static/media/default_outlet_logo.2ac6c14e.svg";